import { Box, Grid, Icon, Stack, Typography, IconButton } from "@mui/material";
import React, { useState } from "react";
import LGModal from "../../../molecules/LGModal";
import ConfirmDialog from "../../../molecules/Common/ConfirmDialog";
import { deleteProviderContact } from "../../../api/providers";
import { useSnack } from "../../../services/SnakbarProvider";
import { handleError } from "../../../services/errorHandler";
import AddContactForm from "../AddContactForm/index.tsx";

export default function ContactItem({ props, onChange }) {
  const { id: contactId, name, contactType, email, phone, mobile, ext, providerId } = props;
  const [openModal, setOpenModal] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const { openSnack } = useSnack();

  const handleModalClose = () => {
    setOpenModal(false);
    if (onChange) {
      onChange();
    }
  };

  const handleCloseDialog = () => {
    setOpenConfirm(false);
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteProviderContact(contactId);
      openSnack("Contacto eliminado correctamente", "success");
      handleCloseDialog();
      if (onChange) {
        onChange();
      }
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  return (
    <>
      <LGModal
        open={openModal}
        header="Editar Contacto"
        handleClose={handleModalClose}
      >
        <AddContactForm
          contactId={contactId}
          providerId={providerId}
          initialValues={{
            name,
            contactTypeId: contactType?.id || "",
            email,
            phone,
            mobile,
            ext,
            acceptsCreceipts: props.acceptsCreceipts || false,
          }}
          onSubmit={handleModalClose}
        />
      </LGModal>

      <ConfirmDialog
        open={openConfirm}
        handleClose={handleCloseDialog}
        handleConfirm={handleConfirmDelete}
      />

      <Box mt={4}>
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <Typography variant="h6">
              {name} | {contactType?.name || ""}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Stack direction="row">
              <IconButton color="primary" onClick={() => setOpenModal(true)}>
                <Icon>edit</Icon>
              </IconButton>
              <IconButton color="error" onClick={() => setOpenConfirm(true)}>
                <Icon>delete</Icon>
              </IconButton>
            </Stack>
          </Grid>
        </Grid>
        <Box m={1} />
        <Grid container>
          <Grid item xs={12}>
            <Stack alignItems="center" direction="row" gap={2}>
              <Icon>email</Icon>
              <Typography>{email}</Typography>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Stack alignItems="center" direction="row" gap={2}>
              <Icon>phone</Icon>
              <Typography>{phone}</Typography>
              {ext && (
                <Typography variant="button" color={"primary.main"}>
                  ext.
                </Typography>
              )}
              {ext && <Typography variant="button">{ext}</Typography>}
            </Stack>
          </Grid>
          {mobile && (
            <Grid item xs={12}>
              <Stack alignItems="center" direction="row" gap={2}>
                <Icon>smartphone</Icon>
                <Typography>{mobile}</Typography>
              </Stack>
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
}
